module.exports = __webpack_public_path__ + "static/media/ui-ux-background@mobile.c7cdd5c9.svg";